export default __webpack_public_path__ + "static/sublimation1-df35f46a81a5c4d05f8f576c4b403551.jpg";